<div class="content-wrapper" *ngIf="status">
  <app-loading-panel [showLoading]="loading" [variant]="'overlay'"/>
  <app-profile-title [title]="'public.profile.edit' | translate" [backTo]="'profile'"/>
  <div class="picture-panel">
    <app-image-upload [image]="image" [uploadText]="'public.global.uploadImage' | translate" [maxWidth]="137"
      [maxHeight]="137" (fileUpload)="handleProfilePictureUpload($event)" (fileDelete)="handleProfilePictureDelete()" />
  </div>
  <div class="content p-3">
    <form class="mx-3" [formGroup]="profileForm" (submit)="handleSubmit($event)">
      <!-- Your name -->
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <app-input-text class="mb-4" inputId="firstName" autocomplete="given-name" [maxLength]="200"
              [label]="'public.profile.firstName' | translate" [required]="true" [control]="getControl('firstName')"
              [isInvalid]="getControl('firstName').invalid && (getControl('firstName').touched || getControl('firstName').dirty)"
              [errorText]="getControl('firstName').hasError('required') ? ('public.checkout.errors.fieldRequired' | translate) : ''" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <app-input-text class="mb-4" inputId="lastName" autocomplete="family-name" [maxLength]="200"
              [label]="'public.profile.lastName' | translate" [required]="true" [control]="getControl('lastName')"
              [isInvalid]="getControl('lastName').invalid && (getControl('lastName').touched || getControl('lastName').dirty)"
              [errorText]="getControl('lastName').hasError('required') ? ('public.checkout.errors.fieldRequired' | translate) : ''" />
          </div>
        </div>
      </div>
      <!-- Email -->
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <app-input-text class="mb-4" inputId="email" autocomplete="email" [maxLength]="200"
              [label]="'public.checkout.email' | translate" [isDisabled]="true" [required]="true"
              [control]="getControl('email')" [inputType]="'email'"
              [isInvalid]="getControl('email').invalid && (getControl('email').touched || getControl('email').dirty)"
              [errorText]="getControl('email').hasError('required') ? ('public.checkout.errors.fieldRequired' | translate) : ''" />
          </div>
        </div>
      </div>
      <!-- Phone Number -->
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <app-phone-input [id]="'phoneNumber'" [countryCode]="countryCode()" [countryName]="getCountryNameCode()"
              [formControl]="getControl('phoneNumber')" [required]="true"
              [invalidSubmit]="getControl('phoneNumber').invalid && getControl('phoneNumber').touched">
            </app-phone-input>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-sm-6 col-md-6 mb-3">
          <span><app-button startIcon="fa-save" type="submit" class="mr-2" [customStyles]="{'min-width':'130px'}">{{
              'public.profile.save' | translate
              }}
            </app-button></span>
          <span class="ml-3"><app-button variant="link" (click)="handleCancel($event)">{{
              'public.dialog.cancel' | translate
              }}
            </app-button></span>
        </div>
        <div class="col-sm-6 col-md-6 text-sm-right">
          <app-button startIcon="fa-trash" variant="danger" (click)="handleDelete($event)">{{
            'public.profile.delete' | translate }}
          </app-button>
        </div>
      </div>
    </form>
  </div>
</div>
